import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getLanguageFromPath } from '../../utils/routes';

const content = {
  en: {
    title: 'About Tarkov Stash',
    paragraphs: [
      'Tarkov Stash is an independent fan-made progression tracker and guide hub for Escape from Tarkov players.',
      'The goal of the project is to make quest tracking, hideout planning, Kappa item collection, and story progression easier to understand across English, Turkish, and Russian routes.',
      'We focus on practical tools, clear navigation, and useful long-form guide pages that help players plan what to do next in raid.',
      'Tarkov Stash is not affiliated with Battlestate Games. It is built for the community and uses publicly available game data and community-friendly resources.',
    ],
  },
  tr: {
    title: 'Tarkov Stash Hakkında',
    paragraphs: [
      'Tarkov Stash, Escape from Tarkov oyuncuları için hazırlanmış bağımsız bir fan yapımı ilerleme takipçisi ve rehber merkezidir.',
      'Projenin amacı görev takibini, hideout planlamasını, Kappa eşya toplamayı ve hikaye ilerlemesini İngilizce, Türkçe ve Rusça rotalarda daha anlaşılır hale getirmektir.',
      'Oyuncuların raid öncesinde bir sonraki adımı daha rahat planlayabilmesi için pratik araçlara, net navigasyona ve faydalı uzun rehber sayfalarına odaklanıyoruz.',
      'Tarkov Stash, Battlestate Games ile bağlantılı değildir. Topluluk için geliştirilmiştir ve herkese açık oyun verileri ile topluluk kaynaklarından yararlanır.',
    ],
  },
};

function AboutUs() {
  const { language } = useLanguage();
  const location = useLocation();
  const lang = (getLanguageFromPath(location.pathname) || language) === 'tr' ? 'tr' : 'en';
  const copy = content[lang];

  return (
    <main className="max-w-4xl mx-auto px-6 py-12 text-zinc-200">
      <h1 className="text-3xl md:text-4xl font-black text-white mb-8">{copy.title}</h1>
      <div className="space-y-5">
        {copy.paragraphs.map((paragraph) => (
          <p key={paragraph} className="text-sm md:text-base leading-8 text-zinc-400">{paragraph}</p>
        ))}
      </div>
    </main>
  );
}

export default AboutUs;
